import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FreeticketService } from '../../../core/services/freeticket/freeticket.service';
import { DatePipe } from '@angular/common';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-freecodemodal',
  templateUrl: './freecodemodal.component.html',
  styleUrls: ['./freecodemodal.component.css']
})
export class FreecodemodalComponent implements OnInit {

  freeticketform: any;
  loading$: any;
  userprivileges: any;

  constructor(private fb: FormBuilder, private toastrService: ToastrService, private freeticketservice: FreeticketService, private datepipe: DatePipe,
    private changedetect: ChangeDetectorRef, private dialogref: MatDialogRef<FreecodemodalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
      this.userprivileges = localStorage.getItem('authority');
      this.userprivileges = JSON.parse(this.userprivileges);
    }

  ngOnInit(): void {
    this.freeticketform = this.fb.group({idfreeticket: '',
    type: [(this.data.freeticket ? 'ticket' : ''), [Validators.required]],
    prix: [0],
    comment: ['', Validators.required]
  });
  // console.log(this.data);
  }

  onsubmit(): any {
    this.freeticketservice.generateTicketCode(this.freeticketform.value).subscribe((response: any) => {
      console.log(response);
      if (this.data.freeticket){
        this.dialogref.close(response.freeticketcode);
      }else{
        this.dialogref.close(false);
      }
      // this.dialogref.close(response.body);
      this.toastrService.success('Code genere avec success, valide jusqu\'au ' + this.datepipe.transform(response.expirationDate, 'dd-MM-yyyy HH:mm:ss'), 'Code ' + this.type.value + ' gratuit', {
        timeOut: 10000, progressBar: true, positionClass: 'toast-bottom-right', enableHtml: true
      });
      this.changedetect.detectChanges();
    },
    (err: any) =>{
      console.log(err);
    });
  }

  cancel(): void {
    this.dialogref.close(false);
  }

  get idfreeticket(): any { return this.freeticketform.get('idfreeticket');}

  get type(): any { return this.freeticketform.get('type');}

  get prix(): any { return this.freeticketform.get('prix');}

  get comment(): any { return this.freeticketform.get('comment');}

  numbersonly3(val: any): any {
    const y = this.freeticketform.controls["prix"];
    this.freeticketform.controls["prix"].patchValue(
      y.value.replace(/[^0-9]/g, "")
    );
  }

  confirmBox(data: any){
    Swal.fire({
      title: 'Etes vous sure?',
      text: 'Vous allez genere un code gratuit!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.onsubmit();
        Swal.fire(
          'Genere code!',
          'Code gratuit genere.',
          'success'
        )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annuler',
          'Operation annuler :)',
          'error'
        );
      }
    });
  }


}
